import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { axiosToObservable } from '../core/clients/axiosToObservable';

import {
  IAuditLog,
} from '.';
import { BidClient } from '../core/clients';

export class AuditService {
  postAuditService = (auditLog: IAuditLog): Observable<any> => {
    return axiosToObservable(BidClient.post('AuditLog/Add/', auditLog)).pipe(
      map((response: any) => {
        return response?.data;
      })
    );
  }
}